import { Tabs } from '@statsbomb/kitbag-components';
import { ReactNode } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { METRIC_KEY, PITCH_PREVIEW_TAB } from '@/consts/searchKeys';
import { useEntityPreviewHeader } from '@/hooks/useEntityPreviewHeader';
import { useQueryParam } from '@/hooks/useQueryParam';
import { useResetSelectionLayer } from '@/hooks/useResetSelectionLayer';
import { useRightPanelHeader } from '@/hooks/useRightPanelHeader/useRightPanelHeader';
import { useUpdateQueryString } from '@/hooks/useUpdateQueryString';
import { Entity } from '@/types/entity';
import { PreviewTab, Tab } from '@/types/tabs';

const validPreviewTabs = Object.values(PreviewTab);

export const EntityMetricPreview = ({
  entity,
  primaryPanel,
  comparisonPanel,
  primaryLabel,
  comparisonLabel,
}: {
  entity: Entity;
  primaryPanel: ReactNode;
  comparisonPanel?: ReactNode;
  primaryLabel: string;
  comparisonLabel: string;
}) => {
  const resetSelectionLayer = useResetSelectionLayer();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const updateQueryString = useUpdateQueryString(searchParams);
  const previewTabParam = useQueryParam(PITCH_PREVIEW_TAB);

  const title = useEntityPreviewHeader();
  const onClose = () => {
    resetSelectionLayer();
    navigate(`./..?${updateQueryString([], [METRIC_KEY, `${entity}Id`, PITCH_PREVIEW_TAB])}`);
  };
  useRightPanelHeader(title, onClose);

  const isComparison = !!comparisonPanel;
  const activeTab = validPreviewTabs.find(tab => tab === previewTabParam) ?? PreviewTab.PRIMARY;
  const isComparisonTab = isComparison && activeTab === PreviewTab.COMPARISON;

  const tabs = [
    { value: PreviewTab.PRIMARY, label: primaryLabel },
    { value: PreviewTab.COMPARISON, label: comparisonLabel },
  ];

  return (
    <>
      {isComparison && (
        <Tabs
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={(_: MouseEvent, { value }: Tab<PreviewTab>) =>
            navigate({ search: updateQueryString([{ key: PITCH_PREVIEW_TAB, value }]) })
          }
        />
      )}
      {isComparisonTab ? comparisonPanel : primaryPanel}
    </>
  );
};
